import { render, staticRenderFns } from "./AuditorLayoutBasic.vue?vue&type=template&id=7c90a49f&scoped=true"
import script from "./AuditorLayoutBasic.vue?vue&type=script&lang=js"
export * from "./AuditorLayoutBasic.vue?vue&type=script&lang=js"
import style0 from "./AuditorLayoutBasic.vue?vue&type=style&index=0&id=7c90a49f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90a49f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c90a49f')) {
      api.createRecord('7c90a49f', component.options)
    } else {
      api.reload('7c90a49f', component.options)
    }
    module.hot.accept("./AuditorLayoutBasic.vue?vue&type=template&id=7c90a49f&scoped=true", function () {
      api.rerender('7c90a49f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/AuditorLayoutBasic.vue"
export default component.exports